import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import { ActionBarProps as Props } from '../../types';

import s from './SimpleActionBar.scss';

const SimpleActionBar: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  isOwner,
  className,
}) => {
  const { hasMoreActions, isCommentable, isEditable, isDeletable } = useDeviationAttributes(
    deviation,
    isOwner
  );

  return (
    <ActionBarStrip className={className}>
      <CentralColumn className={s['root']}>
        <div className={s['left-side']}>
          {isCommentable && (
            <span className={s['icon']}>
              <CommentButton deviation={deviation} isOwner={isOwner} />
            </span>
          )}
        </div>
        <div className={s['right-side']}>
          {isDeletable && (
            <span className={s['icon']}>
              <DeleteButton deviation={deviation} />
            </span>
          )}
          {isEditable && (
            <span className={s['icon']}>
              <EditButton deviation={deviation} />
            </span>
          )}
          {hasMoreActions && (
            <span className={s['icon']}>
              <MoreButton deviation={deviation} />
            </span>
          )}
        </div>
      </CentralColumn>
    </ActionBarStrip>
  );
};
SimpleActionBar.displayName = 'SimpleActionBar';

export default SimpleActionBar;
